import React from 'react'
import DatePicker from 'react-datepicker'
import DateInput from './date-input'

export default function  DateInputWrapper(props) {
  return <label className='game-form-label' onClick={e => e.preventDefault()}>
    {props.label}
    <DatePicker
      customInput={<DateInput />}
      onChange={props.onChange}
      selected={props.date}
      minDate={props.minDate}
      disabled={props.disabled}
    />
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
}
